import { render, staticRenderFns } from "./LeagueTableWidgetEfl.vue?vue&type=template&id=27834b28&scoped=true"
import script from "./LeagueTableWidgetEfl.vue?vue&type=script&lang=js"
export * from "./LeagueTableWidgetEfl.vue?vue&type=script&lang=js"
import style0 from "./LeagueTableWidgetEfl.vue?vue&type=style&index=0&id=27834b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27834b28",
  null
  
)

export default component.exports